export const fetchGoogleSheetData = async (spreadsheetId, range) => {
  try {
    if (window.gapi && window.gapi.client) {
      const response = await window.gapi.client.sheets.spreadsheets.values.get({
        spreadsheetId,
        range,
      });
      return response.result.values;
    }
  } catch (e) {
    console.error('Error fetching Google Sheet data', e);
  }
  // Fallback mock data
  return [['A1', 'B1'], ['A2', 'B2']];
};
